// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ToTopOutlinedSvg from "@fishx/icons-svg/es/asn/ToTopOutlined";
import FishxIcon from '../components/FishxIcon';

var ToTopOutlined = function ToTopOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ToTopOutlinedSvg
  }));
};

ToTopOutlined.displayName = 'ToTopOutlined';
export default React.forwardRef(ToTopOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ToTopOutlined.js
// module id = 4268
// module chunks = 0